import React,{useState,useEffect} from 'react';

import {toast, Toast} from 'react-toastify';
import {FaTimes} from 'react-icons/fa';
import {Container,Content,Header,Form,CoresContainer,Input} from './styles';

import moment from 'moment';
import {api} from '../../../../services/api';

export function Modal({isOpen,setIsOpen,businessData}) {

  const [idBusiness,setIdBusiness] = useState('');
  const [idCustomized,setIdCustomized] = useState('');
  const [idPixelGoogle,setIdPixelGoogle] = useState('');
  const [openingDate,setOpeningDate] = useState(''); 
  const [cnpj,setCnpj] = useState('');
  const [address,setAddress] = useState('');

  const [colorBgHeader,setColorBgHeader] = useState('');
  const [colorLabel,setColorLabel] = useState('');
  const [colorBorderInput,setColorBorderInput] = useState('');
  const [colorBgBottom,setColorBgBottom] = useState('');
  const [colorButtonBottom,setcolorButtonBottom] = useState('');
  const [colorButton,setColorButton] = useState('');
  const [colorShadow,setColorShadow] = useState('');
  const [colorTransversalBar,setColorTransversalBar] = useState('');

  //moment(date).format("YYYY-MM-DD"
  useEffect(() => {
    console.log(businessData)
    setIdBusiness(businessData?.idBusiness);
    setIdCustomized(businessData?.idCustomized !== null ? businessData?.idCustomized : '');
    setIdPixelGoogle(businessData?.idPixelGoogle !== null ? businessData?.idPixelGoogle : '');
    setOpeningDate(moment(new Date(businessData?.openingDate)).format('YYYY-MM-DDThh:mm'))
    setCnpj(businessData?.cnpj)
    setAddress(`${businessData?.city} ${businessData?.neighborhood} ${businessData.state}`)
    setColorBgHeader(businessData?.colorBgHeader)
    setColorLabel(businessData?.colorLabel);
    setColorBorderInput(businessData?.colorBorderInput);
    setColorButton(businessData?.colorButton);
    setcolorButtonBottom(businessData?.colorButtonBottom);
    setColorBgBottom(businessData?.colorBgBottom);
    setColorShadow(businessData?.colorShadow);
    setColorTransversalBar(businessData?.colorTransversalBar);
  },[businessData])

  async function handleUpdate(){
    try {
      let obj = {
        idBusiness: idBusiness,
        idCustomized: idCustomized,
        idPixelGoogle: idPixelGoogle,
        dtInauguracao: openingDate,
        colorBgHeader: colorBgHeader,
        colorLabel: colorLabel,
        colorBgBottom: colorBgBottom,
        colorButtonBottom: colorButtonBottom,
        colorButton: colorButton,
        colorBorderInput: colorBorderInput,
        colorShadow: colorShadow,
        colorTransversalBar: colorTransversalBar
      }
      const response = await api.put('/updateBusinessConfigurations',obj,{
        headers: {
              'Content-Type': 'application/json',
              token: localStorage.getItem('@Inoveclube:token')
        }
      })
      toast.success('Empresa atualizada com sucesso !');
      setIsOpen();
    }
    catch(error){
      toast.error('Erro ao atualizar empresa !');  
    }
  }

  return (
    <Container isOpen={isOpen}>
        <Content isOpen={isOpen}>
            <Header>
                <h2>{businessData.name}</h2>

                <button onClick={setIsOpen}>
                  <FaTimes/>
                </button>
            </Header>

            <Form>
                <div>
                <label htmlFor="">Endereço</label>
                <Input 
                  type="text"
                  placeholder='endereço'
                  value={address}
                  disabled
                />

                <label htmlFor="">CNPJ</label>
                <Input 
                  type="text"
                  placeholder='cnpj'
                  value={cnpj}
                  disabled
                />


                <label htmlFor="idCustomizado">Id Customizado</label>
                <Input 
                  id='idCustomizado'
                  type="text"
                  placeholder='Id Customizado'
                  value={idCustomized}
                  onChange={(event) => setIdCustomized(event.target.value)}
                />

                <label htmlFor="data">Data e Hora de Inauguração</label>
                <Input 
                  id='data'
                  type={"datetime-local"} 
                  value={openingDate}
                  onChange={(event) => setOpeningDate(event.target.value)}
                />

                <label htmlFor="idPixelGoogle">Tag Google Pixel</label>
                <Input
                  id='idPixelGoogle' 
                  type="text" 
                  value={idPixelGoogle}
                  onChange={(event) => setIdPixelGoogle(event.target.value)}
                />

                <CoresContainer>
                    <h3>Personalização do site</h3>
                    
                    <div className="color-container">
                        <div className='color'>
                          <label htmlFor="colorBg">Cor de Fundo</label>
                          <input 
                            id='colorBg'
                            type="color" 
                            value={colorBgHeader}
                            onChange={(event) => setColorBgHeader(event.target.value)}
                          />
                        </div>

                        <div className='color'>
                          <label htmlFor="colorLabel">Cor do texto</label>
                          <input 
                            id='colorLabel'
                            type="color" 
                            value={colorLabel}
                            onChange={(event) => setColorLabel(event.target.value)}
                          />
                        </div>

                        <div className='color'>
                          <label htmlFor="colorBorderInput">Cor da Borda</label>

                          <input  
                            type="color" 
                            id='colorBorderInput'
                            value={colorBorderInput}
                            onChange={(event) => setColorBorderInput(event.target.value)}
                          />
                        </div>
                    </div>

                    <div className='color-container'>
                      <div className='color'>
                        <label htmlFor="colorBotoao">Cor do Botão</label>
                        
                        <input 
                          id='colorButton'
                          type="color" 
                          value={colorButton}
                          onChange={(event) => setColorButton(event.target.value)}
                        />
                      </div>

                      <div className='color'>
                        <label htmlFor="colorButtonBottom">Cor Botão Menu</label>
                        <input 
                          id='colorButtonBottom'
                          type="color" 
                          value={colorButtonBottom}
                          onChange={(event) => setcolorButtonBottom(event.target.value)}
                        />
                      </div>

                      <div className='color'>
                        <label htmlFor="colorBgBottom"> Cor Menu Inferior</label>

                        <input 
                          id='colorBgBottom'
                          type="color" 
                          value={colorBgBottom}
                          onChange={(event) => setColorBgBottom(event.target.value)}
                        />
                      </div>
                    </div>

                    <div className="color-container">
                      <div className='color'>
                        <label htmlFor="colorShadow">Cor da Sombra</label>

                        <input 
                          id='colorShadow'
                          type="color" 
                          value={colorShadow}
                          onChange={(event) => setColorShadow(event.target.value)}
                        />
                      </div>

                      <div className='color'>
                        <label htmlFor="colorTransversalBar">Cor da Barra Transversal</label>
                        <input 
                          id='colorTransversalBar'
                          type="color" 
                          value={colorTransversalBar}
                          onChange={(event) => setColorTransversalBar(event.target.value)}
                        />
                      </div>
                    </div>
                </CoresContainer>
                </div>
                
                <button onClick={handleUpdate}>Editar</button>
            </Form>
        </Content>
    </Container>
  )
}
